/* ==========================================================
   Favoritos (lista de deseos)
   Sin una app de cuentas/wishlist conectada, se guarda en
   localStorage por handle de producto. Funciona en este
   navegador/dispositivo; no se sincroniza entre dispositivos
   ni sobrevive a borrar datos del navegador -- si en el futuro
   se conecta una app de wishlist real, esto se puede sustituir
   sin tocar el marcado (los botones ya llevan data-favorito).
   ========================================================== */
window.mifajaFavoritos = (function () {
  'use strict';
  var CLAVE = 'mifaja_favoritos';

  function leer() {
    try {
      var crudo = window.localStorage.getItem(CLAVE);
      var lista = crudo ? JSON.parse(crudo) : [];
      return Array.isArray(lista) ? lista : [];
    } catch (e) {
      return [];
    }
  }

  function guardar(lista) {
    try { window.localStorage.setItem(CLAVE, JSON.stringify(lista)); }
    catch (e) { /* almacenamiento no disponible (modo privado, cuota, etc.) */ }
  }

  function tiene(handle) {
    return leer().indexOf(handle) !== -1;
  }

  function alternar(handle) {
    var lista = leer();
    var pos = lista.indexOf(handle);
    if (pos === -1) { lista.push(handle); } else { lista.splice(pos, 1); }
    guardar(lista);
    actualizarContador();
    return pos === -1; /* true si se acaba de añadir */
  }

  function todos() {
    return leer();
  }

  function actualizarContador() {
    var n = leer().length;
    document.querySelectorAll('[data-favoritos-contador]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  function pintarBotones(raiz) {
    (raiz || document).querySelectorAll('[data-favorito]').forEach(function (b) {
      var handle = b.getAttribute('data-favorito');
      b.classList.toggle('on', tiene(handle));
      b.setAttribute('aria-pressed', tiene(handle) ? 'true' : 'false');
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    pintarBotones();
    actualizarContador();

    document.body.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-favorito]');
      if (!btn) return;
      e.preventDefault();
      var handle = btn.getAttribute('data-favorito');
      var añadido = alternar(handle);
      btn.classList.toggle('on', añadido);
      btn.setAttribute('aria-pressed', añadido ? 'true' : 'false');
    });
  });

  return { tiene: tiene, alternar: alternar, todos: todos, pintarBotones: pintarBotones };
})();
